// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partStateButton_button__NyMTF {
  background-color: var(--greyTaskBtn);
  border: none;
  text-transform: uppercase;
  color: var(--white);
  font-weight: bold;
  font-size: 1rem;
  transition: filter 0.3s ease;
}

.partStateButton_buttonContent__7Yudf {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.3rem;
}

.partStateButton_title__jnwpW {
  padding-left: 0.4rem;
}

.partStateButton_button__NyMTF:hover {
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
  offset: 0.5;
}

.partStateButton_button__NyMTF {
  border: none;
  cursor: pointer;
}

.partStateButton_todo__Qf4Oe {
  background-color: var(--black25);
}

.partStateButton_active__B\\+tlx {
  background-color: var(--lightMain);
}

.partStateButton_done__ZBYJG {
  background-color: var(--darkGreen);
}
`, "",{"version":3,"sources":["webpack://./src/components/Buttons/css/partStateButton.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;EACpD,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC","sourcesContent":[".button {\n  background-color: var(--greyTaskBtn);\n  border: none;\n  text-transform: uppercase;\n  color: var(--white);\n  font-weight: bold;\n  font-size: 1rem;\n  transition: filter 0.3s ease;\n}\n\n.buttonContent {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.3rem;\n}\n\n.title {\n  padding-left: 0.4rem;\n}\n\n.button:hover {\n  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));\n  offset: 0.5;\n}\n\n.button {\n  border: none;\n  cursor: pointer;\n}\n\n.todo {\n  background-color: var(--black25);\n}\n\n.active {\n  background-color: var(--lightMain);\n}\n\n.done {\n  background-color: var(--darkGreen);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `partStateButton_button__NyMTF`,
	"buttonContent": `partStateButton_buttonContent__7Yudf`,
	"title": `partStateButton_title__jnwpW`,
	"todo": `partStateButton_todo__Qf4Oe`,
	"active": `partStateButton_active__B+tlx`,
	"done": `partStateButton_done__ZBYJG`
};
export default ___CSS_LOADER_EXPORT___;
